export const API_LOGIN_AUTH = '/login/auth';
export const API_LOGIN_REFRESH = '/login/refresh';
